module.exports = __webpack_public_path__ + "img/elementlengths_jakp.9ca69217.png";